import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { IconTile } from '@atlaskit/icon';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Stack, xcss, Text } from '@atlaskit/primitives';

const i18n = defineMessages({
	deletedGroup: {
		id: 'share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroup',
		defaultMessage: 'This group was deleted',
		description: 'The name shown for the deleted group in the specific access component',
	},
});

const principalDetailsStyle = xcss({
	overflowWrap: 'anywhere',
});

export const DeletedGroupDetails = ({}) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.150" alignBlock="center">
			<IconTile label="" size="32" appearance="gray" shape="circle" icon={PeopleGroupIcon} />
			<Stack>
				<Stack xcss={principalDetailsStyle}>
					<Inline>
						<Text>{formatMessage(i18n.deletedGroup)}</Text>
					</Inline>
				</Stack>
			</Stack>
		</Inline>
	);
};
